var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-box" }, [
    _c("ul", { staticClass: "cp-rows active" }, [
      _c("li", [
        _vm.canEdit
          ? _c(
              "button",
              {
                staticClass: "btn btn-success",
                on: {
                  click: function($event) {
                    _vm.newItemStatus = true
                  }
                }
              },
              [_vm._v("Add New")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", [
        _c("section", { staticClass: "content-filters" }, [
          _c("div", {}, [
            _c("div", { staticClass: "cof-row" }, [
              _c("div", { staticClass: "cof-field" }, [
                _c("label", [_vm._v("Date Search")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cof-multi flex" },
                  [
                    _c("date-time-picker", {
                      attrs: {
                        "value-type": "String",
                        "value-format": "yyyy-LL-dd",
                        format: "yyyy-LL-dd",
                        "time-picker": false,
                        "auto-close": true,
                        "max-date": _vm.today
                      },
                      model: {
                        value: _vm.searchForm.fromDate,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "fromDate", $$v)
                        },
                        expression: "searchForm.fromDate"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("To")]),
                    _vm._v(" "),
                    _c("date-time-picker", {
                      attrs: {
                        "value-type": "String",
                        "value-format": "yyyy-LL-dd",
                        format: "yyyy-LL-dd",
                        "time-picker": false,
                        "auto-close": true,
                        "max-date": _vm.today
                      },
                      model: {
                        value: _vm.searchForm.toDate,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "toDate", $$v)
                        },
                        expression: "searchForm.toDate"
                      }
                    }),
                    _vm._v("\n                 \n                "),
                    _c(
                      "button",
                      {
                        staticClass: "main",
                        on: {
                          click: function($event) {
                            return _vm.search()
                          }
                        }
                      },
                      [_vm._v("Search")]
                    ),
                    _vm._v("\n                 \n                "),
                    _c(
                      "button",
                      {
                        staticClass: "second",
                        on: {
                          click: function($event) {
                            return _vm.resetItem()
                          }
                        }
                      },
                      [_vm._v("Reset Filters")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "content-tlist", staticStyle: { margin: "30px 0" } },
          [
            _c(
              "table",
              { staticClass: "content-table" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.notes, function(note) {
                  return _c("tr", { key: note.id }, [
                    _c("td", [
                      _c("span", [_vm._v("Date/Time")]),
                      _vm._v(
                        _vm._s(
                          _vm._f("date")(note.createdAt, "MM/D/YYYY hh:mm A")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("span", [_vm._v("Added By")]),
                        _vm._v(" "),
                        note.system
                          ? [_vm._v("System")]
                          : [
                              _vm._v(
                                _vm._s(note.createdBy.firstName) +
                                  " " +
                                  _vm._s(note.createdBy.lastName)
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [_vm._v("Note")]),
                      _c("div", { domProps: { innerHTML: _vm._s(note.notes) } })
                    ])
                  ])
                }),
                _vm._v(" "),
                !_vm.notes.length
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "empty-table-text",
                          attrs: { colspan: "2" }
                        },
                        [_vm._v("There are no notes")]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ]),
      _vm.newItemStatus
        ? _c("li", [
            _c("h4", [_vm._v("Add New Note")]),
            _vm._v(" "),
            _c("ul", { staticClass: "cp-fields" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profileNote,
                    expression: "profileNote"
                  }
                ],
                staticClass: "textarea-profile-notes",
                attrs: { rows: "5" },
                domProps: { value: _vm.profileNote },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.profileNote = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "cp-fields" }, [
              _c("li", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function($event) {
                        return _vm.saveProfileNotes()
                      }
                    }
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-warning",
                    on: {
                      click: function($event) {
                        _vm.newItemStatus = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Date/Time")]),
      _vm._v(" "),
      _c("th", [_vm._v("Added By")]),
      _vm._v(" "),
      _c("th", [_vm._v("Note")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }